import * as React from "react";

import { DynamicFieldSchema } from "@generation/core";
import { useDataContext } from "@generation/overview-core";

import { withHideOnFieldHoc } from "../Hoc/withHideOnFieldHoc";
import { withRenderFieldHoc } from "../Hoc/withRenderFieldHoc";

export interface DynamicFieldProps {
  name: string;
  field: DynamicFieldSchema;
}

export const DynamicField = withHideOnFieldHoc(
  withRenderFieldHoc((props: DynamicFieldProps) => {
    const values = useDataContext();

    if (!props.field.createOverviewComponent) {
      return null;
    }

    const schema = props.field.getSchema?.(values);
    return <>{props.field.createOverviewComponent(values, props.name, schema)}</>;
  })
);
